module.exports = __webpack_public_path__ + "b3d3e9efb896bb5a8981e609471fd4a9.woff";